import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-upload-progress',
  styles:[`
        .progress {
          margin-top: 10px;
          height: auto;
        }
        .file-display {
          width: max-content;
          display: inline-flex;
          align-items: center;
        }
  `],
  template: `
      <div *ngIf="spSubj|async" class="modal fade in" id="uploadProgressComponent" tabindex="-1" role="dialog" aria-labelledby="Spinner" data-backdrop="static" style="display:block">
          <div class="modal-dialog centered" role="document">
              <div class="modal-content">
                <div class="modal-header">{{fileName}}</div>
                <div class="modal-body">
                  <div class="progress">
                    <mat-progress-bar class="progress-bar" mode="determinate"
                        [value]="uploadProgress" *ngIf="uploadProgress">
                    </mat-progress-bar>

                    <div class="file-display">File Upload: {{ uploadProgress }}%</div>
                  </div>
                </div>
              </div>
          </div>
      </div>
    `
})
export class UploadProgressComponent implements OnInit {

  @Input() fileName: string;
  @Input() uploadProgress: number;
  @Input('showProgress')
  set showProgress(show: boolean){
    this.spSubj.next(show);
  }

  spSubj: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  ngOnInit(): void {
  }

}
